// Stat-card row for the Cases page (Total / Pending / Today's Hearings /
// In Progress / Closed). Pure & presentational: it just renders the `cards`
// it is given. Each card = { label, value, hint, Icon, tint, onClick }.
//
// tint drives the colored icon chip; keep the keys in sync with TINTS below.

const TINTS = {
  blue: "bg-blue-50 text-blue-600",
  amber: "bg-amber-50 text-amber-600",
  green: "bg-emerald-50 text-emerald-600",
  sky: "bg-sky-50 text-sky-600",
  purple: "bg-violet-50 text-violet-600",
};

export default function CaseStatCards({ cards = [], className = "" }) {
  return (
    <div
       className={`grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-5 mb-4 ${className}`}
    >
      {cards.map(({ label, value, hint, Icon, tint = "blue", onClick }) => (
        <button
          key={label}
          type="button"
          onClick={onClick}
          className="group flex items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-left shadow-sm transition-all hover:border-slate-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-yellow-400/40"
        >
          <div className="min-w-0">
            <p className="truncate text-[11px] font-medium text-slate-500">{label}</p>
            <p
              className="truncate text-base font-bold leading-tight tracking-tight text-slate-900 sm:text-lg lg:text-xl"
              title={String(value)}
            >
              {value}
            </p>
            {hint && (
              <span className="mt-0.5 inline-block text-[11px] font-medium text-blue-600 group-hover:underline">
                {hint}
              </span>
            )}
          </div>
          <span
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
              TINTS[tint] || TINTS.blue
            }`}
          >
            {Icon && <Icon className="h-4 w-4" />}
          </span>
        </button>
      ))}
    </div>
  );
}
